<template>
	<v-container grid-list-md text-xs-center>	
		<v-form>
			<v-layout row wrap>        
				<v-flex lg6>
					<label class="blackLabel">Region Type:</label>			
					<v-select :items="regionTypes" @input="fncCheckTypes()" label="Type" v-model="globalModalParams.data.type" required single-line solo item-value="text"></v-select>
				</v-flex>			
				<v-flex lg6>
					<label class="blackLabel">Region Link:</label>
					<v-select :items="regionParents" label="Link Under" v-model="globalModalParams.data.parent" required item-value="id" autocomplete single-line solo></v-select>
				</v-flex>
				<v-flex lg6>
					<label class="blackLabel">Region Name:</label>						
					<v-text-field label="Region Name" v-model="globalModalParams.data.name" required single-line solo></v-text-field>
				</v-flex>
				<v-flex lg6>
					<label class="blackLabel">Region Description:</label>			
					<v-text-field label="Region Description" v-model="globalModalParams.data.description" required single-line solo></v-text-field>
				</v-flex>				
				<div class="pl-4 pr-1 pb-4 buttonHolder">
					<div style="float: right">
						<v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Cancel</v-btn>
						<v-progress-circular indeterminate :width="3" :size="20" v-if="runAdd" color="grey" class="pt-3 loginLoader"></v-progress-circular>
						<v-btn color="success" class="text-xs-right" v-if="!runAdd" @click.stop="fncEditRegion()">Update</v-btn>
                        <small>* The button will activate once all required fields have been completed.</small>
					</div>	
				</div>				
			</v-layout>
		</v-form>	
	</v-container>
</template>

<script>
	import { mapGetters } from 'vuex'; 	
	export default {
	  name: 'RegionEdit',
	  data () {
			return {
				isEditValid: true,	
				regionParent: 0,
				regionTypes: [
					{ id: 'continent', text: 'Continent', },
					{ id: 'country', text: 'Country' },
					{ id: 'province', text: 'Province' },
					{ id: 'district', text: 'District' },
					{ id: 'town', text: 'Town' },
					{ id: 'suburb', text: 'Suburb' }				  
				]
			};
		},		
		methods: {
			fncCheckTypes() {					
				this.$store.dispatch({
					type: 'setObjRegionParents',
                    regionType: this.globalModalParams.data.type
				});
				this.regionParent = 0;
			},
            fncHideModal() {
                this.$store.commit('emptyRegionEdit');
				this.$store.commit('hideModal');
			},
            fncEditRegion() {	              
				this.$store.dispatch({
					type: 'fncEditRegion',					
                    region: this.globalModalParams.data					
				});
			}
		},
		computed: {
			...mapGetters([
				'objAuthorize',
				'globalModalParams',
				'runAdd',
				'regionSelectors',
				'objRegionEdit',
				'regionParents'
			])
		},
		mounted(){
			this.$store.commit('setRegionSelectors');			
		}
	}
</script>

<style scoped>
	/*@import '../../assets/css/shared.css'*/
</style>